import React from 'react'
import Loading from "../components/common/Loading";
import switchStyles from "../styles/desktopMobileSwitch.module.css";
import dynamic from "next/dynamic";
import Head from "next/head";
import EwayBilling from '@/components/EwayBilling';
import ERP from '@/components/ERP';

const eWayBilling = () => {
    return (
        <>
            <Head>
                <title>ERP Software for Retailers, Distributors & Manufacturers</title>
                <link rel="canonical" href="https://queuebuster.co/features/erp-software" />
                <link rel="alternate" href="https://queuebuster.co/features/erp-software" hrefLang="en-us" />
                <meta name="description" content="Whether adopting ERP software for the first time or migrating to the cloud, QueueBuster offers a complete, modern solution with analytics to drive your business" />
                <meta property="og:title" content="ERP Software for Retailers, Distributors & Manufacturers" />
                <meta property="og:description" content="Whether adopting ERP software for the first time or migrating to the cloud, QueueBuster offers a complete, modern solution with analytics to drive your business" />
                <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Images/ALL-IN-ONE_OG.jpg" />
                <meta property="og:url" content="https://queuebuster.co/features/erp-software" />
            </Head>
            <ERP />
        </>
    )
}

export default eWayBilling